/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPersonInfoSearch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M20 2a1 1 0 0 1 1 1v10.375c-.363-.383-.977-.977-2-1.375V4H5v16h1c0-1.438.43-2.937 1.432-4.092C8.453 14.728 9.99 14 12 14c.17 0 .336.005.5.015-.719 1.085-.779 1.991-.779 1.991-1.333.061-2.213.56-2.778 1.211C8.32 17.937 8 18.938 8 20h4.496c.917 1.437 2.413 2 2.413 2H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16zm-6 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm-2-4a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm5 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-4 2a4 4 0 1 1 7.446 2.032l2.261 2.26-1.414 1.415-2.261-2.26A4 4 0 0 1 13 17z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPersonInfoSearch as PersonInfoSearch };
